import { Component } from '@angular/core';

@Component({
  selector: 'app-links-menu',
  templateUrl: './links-menu.component.html',
  styleUrls: ['./links-menu.component.scss']
})
export class LinksMenuComponent {

}
